import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import Loader from './loader/LoaderFullScreen';
import { useAuthQueryParams, useQuery } from '../../hooks/urlHooks';
import { safeNavigateToUrl } from '../../lib/navigationUtils';
import {
  sanitizeHashPath,
  toSafeRedirectHashPath,
} from '../../lib/authRedirectUtils';

const buildSanitizedDefaultQueryString = (rawQueryString: string): string => {
  const queryParams = new URLSearchParams(rawQueryString.replace(/^\?/, ''));
  queryParams.delete('token');
  queryParams.delete('redirectUrl');
  queryParams.delete('referrerUrl');

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
};

const DefaultRoute = () => {
  const queryString = useAuthQueryParams();
  const sanitizedQueryString = buildSanitizedDefaultQueryString(queryString);
  const { redirectUrl } = useQuery();
  const navigate = useNavigate();
  const location = useLocation();
  const currentHashPath = sanitizeHashPath(location.pathname, location.search);
  const safeRedirectHashPath = toSafeRedirectHashPath(
    redirectUrl,
    currentHashPath,
  );

  const { team } = useSelector((state: RootState) => state) || {};
  const { teamId } = team.selectedTeam || {};

  useEffect(() => {
    if (teamId && safeRedirectHashPath) {
      safeNavigateToUrl(safeRedirectHashPath, navigate);
    }
  }, [teamId, safeRedirectHashPath, navigate]);

  if (!teamId) return <Loader />;

  // If redirectUrl exists, the useEffect will handle the navigation
  // Show loader while redirecting
  if (safeRedirectHashPath) {
    return <Loader />;
  }

  return <Navigate to={`/library/${teamId}/recents${sanitizedQueryString}`} />;
};

export default DefaultRoute;
